// Logo.jsx - Save this in src/components/Logo.jsx
import React from 'react';

const Logo = ({ width = 60, height = 60 }) => {
    return (
        <img
            src="/logo.png"
            alt="Adarsh Old Age Care Home Services"
            width={width}
            height={height}
            style={{
                display: 'block',
                objectFit: 'contain'
            }}
        />
    );
};

export default Logo;